import styles from "./styles.css";
import { createGame } from "./app/playgame";
import { player, computer } from "./app/barrel";

createGame(player, computer);
